import { useLayoutEffect, useState } from 'react';

const queries = [
  '(max-width: 767px)',
  '(min-width: 768px) and (max-width: 1279px)',
  '(min-width: 1280px)',
];

const screens = ['isMobile', 'isTablet', 'isDesktop'];

const getMediaValues = mediaQueryLists =>
  mediaQueryLists.map(mql => mql.matches);

const useMatchMedia = () => {
  const getInitialValues = () => {
    if (typeof window === 'undefined') {
      return queries.map(() => false);
    }

    return queries.map(query => window.matchMedia(query).matches);
  };

  const [values, setValues] = useState(getInitialValues);

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;

    const mediaQueryLists = queries.map(query => window.matchMedia(query));

    const update = () => {
      const nextValues = getMediaValues(mediaQueryLists);

      setValues(prevValues => {
        const changed = nextValues.some(
          (value, index) => value !== prevValues[index],
        );

        return changed ? nextValues : prevValues;
      });
    };

    mediaQueryLists.forEach(mql => {
      mql.addEventListener('change', update);
    });

    const resizeObserver = new ResizeObserver(update);

    resizeObserver.observe(document.documentElement);

    update();

    return () => {
      mediaQueryLists.forEach(mql => {
        mql.removeEventListener('change', update);
      });

      resizeObserver.disconnect();
    };
  }, []);

  return screens.reduce(
    (acc, screen, index) => ({
      ...acc,
      [screen]: values[index],
    }),
    {},
  );
};

export default useMatchMedia;
